import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { Check, Download } from "lucide-react";
import { homeServices, pricing, images, company } from "../mock/mock";
import { PageHero, SectionHeading, PrimaryButton, CTABanner } from "../components/Common";

const WhatWeDo = () => {
  return (
    <div>
      <PageHero
        eyebrow="What We Do"
        title="Outsource your Call Centre Needs"
        subtitle="Contact centre outsourcing made easy. 160 hours per agent every month with a 30-day money-back guarantee. See how we help you in B2B lead generation, debt collection, answering services and insurance claims operations."
        image={images.ccFloor}
      />

      {/* Intro cards */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-10">
          <div className="rounded-2xl border border-border overflow-hidden card-lift">
            <div className="img-zoom h-56">
              <img src={images.finance} alt="Pricing" className="w-full h-full object-cover" />
            </div>
            <div className="p-8">
              <h3 className="font-heading font-bold text-navy text-xl mb-3">
                Pricing Structure for Business Process Outsourcing
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed mb-4">
                As low as <strong className="text-navy">$800.00 per month / agent</strong> with annual pre-pay for teams
                of 10 or more. We provide outsourcing at highly competitive rates with flexible models.
              </p>
              <ul className="space-y-2 text-sm">
                <li className="flex gap-2"><Check size={16} className="text-gold-dark mt-0.5" /> Full-time employees (160 hrs/month)</li>
                <li className="flex gap-2"><Check size={16} className="text-gold-dark mt-0.5" /> Half resource option (80 hrs/month)</li>
                <li className="flex gap-2"><Check size={16} className="text-gold-dark mt-0.5" /> Annual pre-pay & project-based pricing</li>
              </ul>
            </div>
          </div>
          <div className="rounded-2xl border border-border overflow-hidden card-lift">
            <div className="img-zoom h-56">
              <img src={images.salesTeam} alt="Lead qualification" className="w-full h-full object-cover" />
            </div>
            <div className="p-8">
              <h3 className="font-heading font-bold text-navy text-xl mb-3">
                B2B Sales, Lead & Appointment Generation
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed mb-4">
                We understand the cost behind a bad lead and continuously put efforts to zero-down
                these errors. We aim to provide best-in-industry services with a managed budget.
              </p>
              <PrimaryButton to="/leads-on-demand">See Lead Generation Solutions</PrimaryButton>
            </div>
          </div>
        </div>
      </section>

      {/* All services grid */}
      <section className="bg-secondary py-20">
        <div className="max-w-7xl mx-auto px-6">
          <SectionHeading
            center
            eyebrow="Our Services"
            title="All contact centre & BPO services"
            subtitle="One partner for healthcare answering, insurance claims, debt recovery, legal, contractor support and B2B sales."
          />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {homeServices.map((s) => {
              const Icon = Icons[s.icon] || Icons.Circle;
              return (
                <Link key={s.title} to={s.to} className="group bg-white rounded-2xl p-7 border border-border card-lift">
                  <div className="w-12 h-12 rounded-xl brand-gradient flex items-center justify-center mb-5">
                    <Icon size={22} className="text-gold-light" />
                  </div>
                  <h3 className="font-heading font-bold text-navy text-lg mb-2 group-hover:text-navy-light transition-colors">{s.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Recognition */}
      <section className="bg-white py-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <SectionHeading
            center
            eyebrow="Recognition"
            title="North Carolina's Best outsourcing solutions"
            subtitle="Mid Atlantic Business Management has been selected and recognized as one of the Top Voice & Call Center Services in Durham, NC by UpCity Inc."
          />
          <div className="grid sm:grid-cols-2 gap-6">
            <div className="rounded-2xl border border-border p-6 flex items-center gap-4">
              <Download size={28} className="text-gold" />
              <div className="text-left">
                <div className="font-heading font-bold text-navy text-sm">Call Centre Services Overview</div>
                <button className="text-xs text-gold-dark font-bold">View or download PDF</button>
              </div>
            </div>
            <div className="rounded-2xl border border-border p-6 flex items-center gap-4">
              <Download size={28} className="text-gold" />
              <div className="text-left">
                <div className="font-heading font-bold text-navy text-sm">B2B Services Overview</div>
                <button className="text-xs text-gold-dark font-bold">View or download PDF</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
};

export default WhatWeDo;
